import { render, staticRenderFns } from "./ReadingChart.vue?vue&type=template&id=2b55b39a&scoped=true&"
import script from "./ReadingChart.vue?vue&type=script&lang=ts&"
export * from "./ReadingChart.vue?vue&type=script&lang=ts&"
import style0 from "./ReadingChart.vue?vue&type=style&index=0&id=2b55b39a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55b39a",
  null
  
)

export default component.exports